import React from 'react'
import { useState } from 'react';
import "./Custom.css";


const Custom = (props) => {
    return (
        <div>
           <label class="container">
            <input type="checkbox" checked = {props.checked === true} onChange={props.onChange}/>
            <span class="checkmark"></span>
           </label>
        </div>
    )
}

export default Custom ;
